module.exports = __webpack_public_path__ + "images/handshake-alt-light.svg";